import React, { Component } from "react";
import { Modal, Checkbox, Col } from "antd";

import styles from "./index.less";

class SelectMember extends Component {
  state = {};

  handleOk = () => {
    const { onOk } = this.props;
    const { selectedList, selectedNameList } = this.state;
    if (onOk) {
      onOk(selectedList, selectedNameList);
    }
  };

  handleChangeChecked = values => {
    const selectedName = [];
    values.map(item => {
      selectedName.push(item.orgName);
    });
    this.setState({
      selectedList: values,
      selectedNameList: selectedName
    });
  };

  renderList = () => {
    const { superviseList } = this.props;
    const { selectedList } = this.state;
    return (
      <Checkbox.Group
        defaultValue={selectedList}
        onChange={this.handleChangeChecked}
      >
        {superviseList.map((item, index) => {
          return (
            <Col span={24} key={item.orgId}>
              <Checkbox value={item}>{item.orgName}</Checkbox>
            </Col>
          );
        })}
      </Checkbox.Group>
    );
  };

  render() {
    const { onCancel, modalTitle } = this.props;
    return (
      <Modal
        title={modalTitle || "请选择评估对象"}
        visible
        centered
        onOk={this.handleOk}
        onCancel={() => onCancel()}
        wrapClassName={styles.memberModal}
      >
        <div className="modal-body-wrap">{this.renderList()}</div>
      </Modal>
    );
  }
}

export default SelectMember;
